import React from 'react';
import {Listbox} from '@headlessui/react';
import getLanguage, {getAvailableFormLanguages, LanguageId} from '../../../models/utils/Languages';
import UIStdOptionList from '../../../ui/form/UIStdOptionList';

type Props = {
  selectedLanguage?: LanguageId
  setSelectedLanguage: (lang: LanguageId) => void
}

/**
 * Filter to check out how the customisable form looks like in another language
 */
export default function LanguageFilter({selectedLanguage, setSelectedLanguage}: Props) {
  const availableLanguages = getAvailableFormLanguages();
  const options = availableLanguages
    .map((langId, index) => ({
      label: getLanguage(langId), value: langId, id: langId, selected: index === 0,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <div className="w-max flex text-base mt-2">
      Check out how the form looks in&nbsp;
      <Listbox value={selectedLanguage} onChange={setSelectedLanguage} as="span">
        {({open}) => (
          <div>
            <Listbox.Button className="font-bold border-b border-dashed cursor-pointer" as="span">
              {getLanguage(selectedLanguage || '')}
            </Listbox.Button>
            <UIStdOptionList options={options} open={open} className="w-max"/>
          </div>
        )}
      </Listbox>
    </div>
  );
}
